import { CheckBox } from "@mui/icons-material";
import { Box, Typography, Checkbox, FormHelperText } from "@mui/material";
import React from "react";
import { Square } from "react-feather";
import { useTranslation } from "react-i18next";

const coachCustomPage = process.env.REACT_APP_BLOG_URL;

const Agreement = ({
  errors,
  setValue,
  coachDetails = null,
  customStyle = {},
}) => {
  const coach_slug = coachDetails?.onboarding?.personal_link ?? null;

  const { t } = useTranslation();
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "10px",
          mt: "32px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Checkbox
            name="terms"
            icon={<Square size={20} />}
            checkedIcon={
              <CheckBox
                sx={{
                  fontSize: "24px",
                  fill: customStyle?.accentColor ?? "var(--color-black)",
                }}
              />
            }
            sx={{
              ...(Boolean(errors?.terms) && {
                color: "red",
              }),
              padding: "0px !important",
            }}
            size={"small"}
            onClick={(e) => setValue("terms", e.target.checked)}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "18px",
              fontFamily: `var(--font-${customStyle?.bodyFont})`,
              color: customStyle?.textColor ?? "#19181B",
            }}
          >
            {t("individual.booking.agreement")}
            <Typography
              variant="caption"
              sx={{
                fontFamily: `var(--font-${customStyle?.bodyFont})`,
                fontSize: "14px",
                lineHeight: "18px",
                cursor: coach_slug ? "pointer" : "default",
                color: customStyle?.accentColor ?? "var(--color-brand-primary)",
              }}
              onClick={() => {
                if (coach_slug) {
                  window.open(
                    `${coachCustomPage}/page/${coach_slug}/terms-and-condition`,
                    "_blank"
                  );
                }
              }}
            >
              {" "}
              {t("individual.booking.agreement.terms")}
            </Typography>
            {` & `}
            <Typography
              variant="caption"
              sx={{
                fontSize: "14px",
                lineHeight: "18px",
                cursor: coach_slug ? "pointer" : "default",
                color: customStyle?.accentColor ?? "var(--color-brand-primary)",
                fontFamily: `var(--font-${customStyle?.bodyFont})`,
              }}
              onClick={() => {
                if (coach_slug) {
                  window.open(
                    `${coachCustomPage}/page/${coach_slug}/privacy-policy`,
                    "_blank"
                  );
                }
              }}
            >
              {t("individual.booking.agreement.policy")}
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Box>
        {Boolean(errors?.terms) && (
          <Box sx={{ ml: "30px" }}>
            <FormHelperText error> {errors?.terms.message} </FormHelperText>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "10px",
          width: "100%",
          mt: "8px",
        }}
      >
        <Checkbox
          name="new_letter"
          icon={<Square size={20} />}
          checkedIcon={
            <CheckBox
              sx={{
                fontSize: "24px",
                fill: customStyle?.accentColor ?? "var(--color-black)",
              }}
            />
          }
          sx={{
            padding: "0px !important",
          }}
        />

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "18px",
            fontFamily: `var(--font-${customStyle?.bodyFont})`,
            color: customStyle?.textColor ?? "#19181B",
          }}
        >
          {t("individual.booking.agreement.news_letter")}
        </Typography>
      </Box>
    </Box>
  );
};

export default Agreement;
